<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    required: true,
  },
  emptyLabel: {
    type: String,
    required: true,
  },
});

const formatTimestamp = value => {
  if (!value) return '';
  const numericValue = Number(value);
  const date = Number.isFinite(numericValue)
    ? new Date(numericValue * 1000)
    : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
};
</script>

<template>
  <div class="flex flex-col gap-3 pt-3">
    <h2 class="text-base font-medium text-n-slate-12">
      {{ title }}
    </h2>
    <div v-if="items.length" class="flex flex-col gap-2">
      <article
        v-for="item in items"
        :key="`${item.title}-${item.occurred_at}`"
        class="rounded-lg border border-n-weak bg-n-solid-2 p-3"
      >
        <div class="text-sm font-medium text-n-slate-12">
          {{ item.title }}
        </div>
        <p class="mt-1 text-sm line-clamp-2 text-n-slate-11">
          {{ item.description }}
        </p>
        <div
          v-if="item.actor_name || item.occurred_at"
          class="mt-2 flex flex-wrap items-center justify-between gap-2 text-xs text-n-slate-10"
        >
          <span v-if="item.actor_name">{{ item.actor_name }}</span>
          <time v-if="item.occurred_at" :datetime="item.occurred_at">
            {{ formatTimestamp(item.occurred_at) }}
          </time>
        </div>
      </article>
    </div>
    <p v-else class="text-sm text-n-slate-11">
      {{ emptyLabel }}
    </p>
  </div>
</template>
